import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewCityList } from "../../Redux/Actions/settingsActions";
import { columnsCity } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";
import { debounce } from 'lodash';
import { Pagination } from "antd";

const ListCity = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { cities } = useSelector((state) => state.city);
  const { states, loading } = useSelector((state) => state.states);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50"],
  });

  const foundState = Array.isArray(states?.data) && states.data.find((item) => item._id === id);
  const countryId = foundState?.country;

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCities, setFilteredCities] = useState([]);

  const debouncedSearch = useCallback(
    debounce((query) => {
      if (!cities?.data || !Array.isArray(cities.data)) return;

      if (!query.trim()) {
        setFilteredCities(cities.data);
        return;
      }

      const filtered = cities.data.filter(city =>
        city.city_name?.toLowerCase().includes(query.toLowerCase()) ||
        city.state_name?.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredCities(filtered);
    }, 300),
    [cities?.data]
  );

  useEffect(() => {
    debouncedSearch(searchQuery);
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchQuery, debouncedSearch]);

  useEffect(() => {
    const cityData = {
      state: id,
      country: countryId,
      page: 1,
      limit: 200,
    };
    dispatch(viewCityList(cityData));
  }, [dispatch, id, countryId]);


  useEffect(() => {
    if (cities?.data && Array.isArray(cities.data)) {
      setFilteredCities(cities.data);
    }
  }, [cities?.data]);

  return (
    <TableComponent
      columns={columnsCity(canEdit)}
      buttonhead="Go Back"
      navigateTo={`/state-list/${countryId}`}
      navigateTo2={canAdd ? `/city/${id}/add` : null}
      buttonhead2={canAdd ? "Add City" : null}
      setState={setSearchQuery}
      h3heading={foundState?.state_name || "No Data"}
      loading={loading}
      pagination={pagination}
      dataSource={Array.isArray(filteredCities) ? filteredCities : []}
      className="city-table-selector ant-select-selector-margin"
    />
  );
};

export default ListCity;
